<div class="emptyState">
    <img [src]="iconUrl" alt="NoData" />
    <span>{{ msg | translate }}</span>
</div>
